package gr.tech.GRAttestation.models.storeusers

import kotlinx.serialization.Serializable

@Serializable
enum class STORE_USERS_STATUS(val bit: Short, val status: String) {
    DELETED(0, "DELETED"),
    DISABLED (1, "DISABLED"),
    ACTIVE(2, "ACTIVE"),
    PENDING(3, "PENDING");

    companion object {
        fun parseStatus(status: String): STORE_USERS_STATUS {
            return when (status.lowercase()) {
                "active" -> STORE_USERS_STATUS.ACTIVE
                "disabled" -> STORE_USERS_STATUS.DISABLED
                "deleted" -> STORE_USERS_STATUS.DELETED
                "pending" -> STORE_USERS_STATUS.PENDING
                else -> STORE_USERS_STATUS.ACTIVE
            }
        }

        fun parseStatus(status: Short): STORE_USERS_STATUS {
            return when (status) {
                0.toShort() -> STORE_USERS_STATUS.DELETED
                1.toShort() -> STORE_USERS_STATUS.DISABLED
                2.toShort() -> STORE_USERS_STATUS.ACTIVE
                3.toShort() -> STORE_USERS_STATUS.PENDING
                else -> STORE_USERS_STATUS.ACTIVE
            }
        }
    }
}